// MainLayout.tsx
import React, { ReactNode, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Layout, Space } from 'antd';

import SideBar from '../../components/layout-components/sideBar';
import TopNavBar from '../../components/layout-components/topNavBar';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <Container fluid className="main-container">
      <TopNavBar />
      <div className="main-router-container">{children}</div>
    </Container>
  );
};

export default MainLayout;
